import { render } from "./AcampanteDetailsModal.vue?vue&type=template&id=3926b6a3&scoped=true"
import script from "./AcampanteDetailsModal.vue?vue&type=script&lang=js"
export * from "./AcampanteDetailsModal.vue?vue&type=script&lang=js"

import "./AcampanteDetailsModal.vue?vue&type=style&index=0&id=3926b6a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3926b6a3"]])

export default __exports__